//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  resource,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { map, Subject, takeUntil } from "rxjs";

// local imports
import { CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";
import { Messenger } from "@app/shared";
import { NavigationService } from "@app/core";

@Component({
  selector: "project-property",
  standalone: false,
  templateUrl: "./project-property.component.html",
  styleUrl: "./project-property.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectPropertyComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private catalogStateService = inject(CatalogStateService);
  private navigationService = inject(NavigationService);
  private messenger = inject(Messenger);

  private readonly destroying$ = new Subject<void>();

  public projectId = toSignal(
     this.route.paramMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.ID)))
  );

  public projectPropertyResource = resource({
    request: () => ({
      id: this.projectId(),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getProjectProperty(
        request.id
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }

      return property;
    },
  });


  public ngOnInit(): void {
    this.catalogStateService.initialize(this.route);

    this.route.queryParamMap.pipe(
      takeUntil(this.destroying$)
    ).subscribe((params) => {
      const projectId = params.get(CatalogCommonConstants.ROUTE_PARAMS.PROJECT_ID);

      if (!projectId) {
        this.navigationService.back();
      }
    });
  }


  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }
}